import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { ItemPrice, PromotionItemPrice, QuotedItemPrice } from '@idealsupply/products-api-angular-client';
import { ItemPricingModel } from 'products-data';
import { ProductFeesViewComponent } from '../../../../fees/product-fees/views/product-fees-view/product-fees-view.component';

@Component({
  selector: 'ideal-item-price-sale-and-fees-info-view',
  imports: [RouterModule, DatePipe, ProductFeesViewComponent, MatButtonModule],
  standalone: true,
  templateUrl: './item-price-sale-and-fees-info-view.component.html',
  styleUrl: './item-price-sale-and-fees-info-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemPriceSaleAndFeesInfoViewComponent {
  public readonly pricing = input<ItemPricingModel>();
  public readonly multiplyBy = input(1);

  protected readonly hasFees = computed(() => (this.pricing()?.fees.length ?? 0) > 0);
  protected readonly isLimitedSale = computed(() => this.pricing()?.isOnSaleLimited ?? false);

  protected $promo(price: ItemPrice): PromotionItemPrice {
    return price as PromotionItemPrice;
  }

  protected $quote(price: ItemPrice): QuotedItemPrice {
    return price as QuotedItemPrice;
  }
}
